import script from "./ProductsCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductsCategory.vue?vue&type=script&setup=true&lang=js"

import "./ProductsCategory.vue?vue&type=style&index=0&id=c9752b24&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9752b24"]])

export default __exports__